(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var announcementBar = document.querySelector('.bar-with-timer');
    var timerDisplay = announcementBar.querySelector('.bar-timer');
    var endDate = new Date(timerDisplay.dataset.date).getTime();

    const daysEl = announcementBar.querySelector('.bar-timer-days');
    const hoursEl = announcementBar.querySelector('.bar-timer-hours');
    const minutesEl = announcementBar.querySelector('.bar-timer-minutes');

    function updateTimer() {
      var now = new Date().getTime();
      var timeRemaining = endDate - now;

      if (timeRemaining <= 0) {
        announcementBar.style.display = 'none';
        return;
      }

      var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      var hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));

      daysEl.innerHTML = pad(days);
      hoursEl.innerHTML = pad(hours);
      minutesEl.innerHTML = pad(minutes);
    }

    function pad(value) {
      return value.toString().padStart(2, '0');
    }

    updateTimer();
    var timerInterval = setInterval(updateTimer, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
